// oc/utils/get-month-list.ts
import moment from "moment";
import "moment/locale/hu";

export interface MonthItem {
  /** 1–12 */
  index: number;
  name: string;
}

/**
 * Visszaadja az év hónapjait a kiválasztott locale szerint.
 * Ha monthList-et is megadsz (számok tömbje), csak azt dolgozza fel,
 * különben a 1–12 hónapokat generálja.
 */
export function getMonthList(
  locale: string,
  monthList?: number[],
): MonthItem[] {
  const year = new Date().getFullYear();
  const months = monthList ?? Array.from({ length: 12 }, (_, i) => i + 1);

  return months.map((month) => {
    // 2025-01-01, 2025-02-01, stb.
    const date = new Date(year, month - 1, 1);
    const monthName = moment(date).locale(locale).format("MMMM");
    return { index: month, name: monthName };
  });
}

export default getMonthList;
